import { useCallback, useEffect, useState } from 'react'
import { GoogleMap, InfoBox, InfoWindow, LoadScript, Marker } from '@react-google-maps/api';
import handleHrefClick from 'lib/handle-href-click';
import Link from 'next/link';

const containerStyle = {
  width: '100%',
  height: '100%'
};

export default function PartnerMap({
  locations = [],
  center,
  focusedLocation = 0,
  sticky,
}) {
  const [map, setMap] = useState(null)
  const [selectedLocation, setSelectedLocation] = useState(0)

  useEffect(() => {
    setSelectedLocation(focusedLocation)
  }, [focusedLocation])

  const onLoad = useCallback((map) => {
    const bounds = new google.maps.LatLngBounds();

    for (const location of locations) {
      bounds.extend({
        lat: location.acf?.main_address?.lat,
        lng: location.acf?.main_address?.lng,
      })
    }

    map.fitBounds(bounds);
    setMap(map)
  })

  const onUnmount = useCallback(() => {
    setMap(null)
  }, [])

  // Don't render the map if there are no markers to show
  if(locations.length < 1) {
    return (<div />)
  }

  return (
    <div className={`wrapper ${sticky ? 'sticky' : ''}`}>
      <LoadScript
        googleMapsApiKey={process.env.NEXT_PUBLIC_GOOGLE_API_KEY || "AIzaSyCcpGtqYJRqm2YgK8-FRQntHLDn-PGqNGg"}
      >
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          onLoad={onLoad}
          onUnmount={onUnmount}
          onClick={() => setSelectedLocation(0)}
        >
          {locations.map((location) => {
            return (
              <Marker
                key={location.id}
                position={{
                  lat: location.acf?.main_address?.lat,
                  lng: location.acf?.main_address?.lng,
                }}
                title={`Locatie ${location.title}`}
                opacity={focusedLocation === 0 || focusedLocation === location.id ? 1 : 0.2}
                title={location.title.rendered}
                onClick={() => setSelectedLocation(selectedLocation !== location.id ? location.id : 0)}
              >
                {selectedLocation === location.id && (focusedLocation === 0 || focusedLocation === location.id) &&
                  <InfoWindow>
                    <>
                      <h5>{location.title.rendered}</h5>
                      <Link onClick={handleHrefClick} href={`/locatie/${location.slug}`}>
                        Bekijk praktijk
                      </Link>
                    </>
                  </InfoWindow>
                }
              </Marker>
            )
          })}
        </GoogleMap>
      </LoadScript>

      <style jsx>{`
        .wrapper {
          height: calc(100vh - 160px);
        }

        .sticky {
          position: -webkit-sticky; /* Safari */
          position: sticky;
          top: 150px;
        }

        @media only screen and (max-width: 991px) {
          .wrapper {
            height: 400px;
          }
        }

        @media only screen and (min-width: 1190px) {
          .sticky {
            top: 100px;
          }

          .wrapper {
            height: calc(100vh - 110px);
          }
        }
      `}</style>
    </div>
  )
}
